import { render, staticRenderFns } from "./SummaryMetrics.vue?vue&type=template&id=c1ac2fc6&scoped=true"
import script from "./SummaryMetrics.vue?vue&type=script&lang=js"
export * from "./SummaryMetrics.vue?vue&type=script&lang=js"
import style0 from "./SummaryMetrics.vue?vue&type=style&index=0&id=c1ac2fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ac2fc6",
  null
  
)

export default component.exports